/**
 * Hide/show content based on referere and/or url param.
 *
 * Scenarios:
 *
 * Internal or external WITH url param:
 *  - Show interal
 *  - Hide external
 *
 * External with NO url param:
 *  - Hide internal
 *  - Show external
 */

document.addEventListener('DOMContentLoaded', () => {
  // Checks it's the single newsroom news page
  if (document.querySelector('body.single-newsroom-news') === null) {
    return;
  }

  const externalElements = document.querySelectorAll('.single-newsroom-news .newsroom-external');
  const internalElements = document.querySelectorAll('.single-newsroom-news .newsroom-internal');
  const location = document.location.host;
  const referrer = document.referrer.replace(/https?:\/\//, '');
  const urlParams = new URLSearchParams(window.location.search);

  // If an external referer and no url param
  if (referrer.indexOf(location) !== 0 && !urlParams.has('sharing')) {
    // Show external components
    Array.from(externalElements).forEach(element => {
      element.style.display = 'block'; // eslint-disable-line no-param-reassign
    });
    // Hide internal components
    Array.from(internalElements).forEach(element => {
      element.style.display = 'none'; // eslint-disable-line no-param-reassign
      // Remove element if possible
      element.remove();
    });

    // Hide secondary menu
    document.getElementById('secondaryNav').style.display = 'none';
    document.getElementById('content').classList.remove('has_secondaryNav');
    // Remove element if possible
    document.getElementById('secondaryNav').remove();

    // Hide notification bar
    document.getElementById('content').classList.remove('has_notificationBanner');
  }
});
